module.exports = __webpack_public_path__ + "6aa7a86b05b3089341689ef481213daa.MP3";